import { render } from "./Eleganza4.vue?vue&type=template&id=345a078c&scoped=true"
import script from "./Eleganza4.vue?vue&type=script&lang=js"
export * from "./Eleganza4.vue?vue&type=script&lang=js"

import "./Eleganza4.vue?vue&type=style&index=0&id=345a078c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-345a078c"

export default script